import { action, thunk } from "easy-peasy";

const leagueSelectionModel = {
    selectedLeagueLevel: localStorage.getItem('selectedLeagueLevel') || '1',

    setLeagueLevel: action((state, payload) => {
        state.selectedLeagueLevel = payload;
        localStorage.setItem('selectedLeagueLevel', payload);
    }),

    changeLeagueLevel: thunk(async (actions, leagueLevel, { getStoreActions }) => {
        actions.setLeagueLevel(leagueLevel);
    }),

    initializeFromStorage: action((state) => {
        const storedLevel = localStorage.getItem('selectedLeagueLevel');
        if (storedLevel) {
            state.selectedLeagueLevel = storedLevel;
        }
    }),
}

export default leagueSelectionModel;
